<template>
  <v-row class="pa-2" no-gutters style="height: 100%;">
    <v-col
      cols="8"
      :style="
        fullscreen ? 'border: 1px solid #eee;' : 'background-color: white;'
      "
    >
      <v-col cols="7" class="mx-auto">
        <div
          v-if="transactions.length && transactions[0].url_photo"
          style="position: relative;"
        >
          <v-img aspect-ratio="1" :src="transactions[0].url_photo"></v-img>
          <v-icon
            x-large
            color="white"
            style="position: absolute; bottom: 0; right: 2px;"
            >mdi-camera
          </v-icon>
        </div>
        <div
          v-else-if="
            transactions.length &&
              transactions[0].employee &&
              transactions[0].employee.url_photo_identifier
          "
          style="position: relative;"
        >
          <v-img
            aspect-ratio="1"
            :src="transactions[0].employee.url_photo_identifier"
          ></v-img>
          <v-icon
            x-large
            color="white"
            style="position: absolute; bottom: 0; right: 2px;"
            >mdi-folder-account
          </v-icon>
        </div>
        <div v-else-if="transactions.length" style="position: relative;">
          <v-img class="grey lighten-4" aspect-ratio="1"></v-img>
          <div
            class="d-flex justify-center"
            style="position: absolute; top: 0; left: 0; right: 0; bottom: 0;"
          >
            <v-icon color="grey" size="64">
              mdi-account
            </v-icon>
          </div>
        </div>
      </v-col>
      <v-col cols="7" class="mx-auto pt-0">
        <div v-if="transactions.length && transactions[0].employee">
          <p class="text-lg text-truncate mb-0">
            {{ transactions[0].employee.firstname_th }}
            {{ transactions[0].employee.lastname_th }}
            <span class="text-md grey--text">
              {{ transactions[0].employee.employee_code }}
            </span>
          </p>
        </div>

        <div v-if="transactions.length">
          <span class="text-lg" v-html="dateTimeFormat(transactions[0])" />
          <span class="grey--text mb-0 text-md">
            {{ dateTimeFromNow(transactions[0].transaction_time) }}
          </span>
        </div>

        <div>
          <div v-if="transactions.length && transactions[0].hardware">
            <p class="mb-0 text-lg">
              {{ transactions[0].hardware.title_th }}
              <span class="grey--text text-md">
                {{ transactions[0].hardware.hardware_code }}
              </span>
            </p>
          </div>
          <div v-else>
            <p
              v-if="transactions.length && transactions[0].transaction_source"
              class="subtitle-1 mb-0"
              :class="{ 'text-xl mt-5': fullscreen }"
            >
              {{ transactions[0].transaction_source.title_short }}
              <span class="grey--text" :class="{ 'text-lg mt-2': fullscreen }">
                {{ transactions[0].device_code_3rdparty }}
              </span>
            </p>
          </div>
        </div>
        <div>
          <div v-if="transactions.length && transactions[0].company_duty">
            <p class="text-lg mb-0">
              สถานะ {{ transactions[0].company_duty.title_th }}
            </p>
          </div>
        </div>
      </v-col>
    </v-col>
    <v-col
      class="pa-2"
      :style="
        !fullscreen ? 'border: 1px solid #BDBDBD;' : 'background-color: #eee;'
      "
    >
      <v-card
        class="mb-2 pa-2"
        outlined
        v-for="transaction in transactions.slice(1)"
        :key="transaction.transaction_uuid"
      >
        <v-row no-gutters>
          <v-col cols="5">
            <div v-if="transaction.url_photo" style="position: relative;">
              <v-img aspect-ratio="1" :src="transaction.url_photo"></v-img>
              <v-icon
                color="white"
                style="position: absolute; bottom: 0; right: 2px;"
                >mdi-camera
              </v-icon>
            </div>
            <div
              v-else-if="
                transaction.employee &&
                  transaction.employee.url_photo_identifier
              "
              style="position: relative;"
            >
              <v-img
                aspect-ratio="1"
                :src="transaction.employee.url_photo_identifier"
              ></v-img>
              <v-icon
                color="white"
                style="position: absolute; bottom: 0; right: 2px;"
                >mdi-folder-account
              </v-icon>
            </div>
            <div v-else style="position: relative;">
              <v-img class="grey lighten-4" aspect-ratio="1"></v-img>
              <div
                class="d-flex justify-center"
                style="position: absolute; top: 0; left: 0; right: 0; bottom: 0;"
              >
                <v-icon color="grey" size="64">
                  mdi-account
                </v-icon>
              </div>
            </div>
          </v-col>
          <v-col cols="6" class="ml-4">
            <div v-if="transaction.employee">
              <p
                class="text-truncate mb-0"
                :class="fullscreen ? 'subtitle-1' : 'text-sm'"
              >
                {{ transaction.employee.firstname_th }}
                {{ transaction.employee.lastname_th }}
              </p>
              <p
                class="grey--text mb-0"
                :class="fullscreen ? 'subtitle-1' : 'text-sm'"
              >
                {{ transaction.employee.employee_code }}
              </p>
            </div>
            <div>
              <div
                :class="fullscreen ? 'subtitle-1' : 'text-sm'"
                v-html="dateTimeFormat(transaction)"
              />
              <p
                class="grey--text mb-0"
                :class="fullscreen ? 'subtitle-1' : 'text-sm'"
              >
                {{ dateTimeFromNow(transaction.transaction_time) }}
              </p>
            </div>
            <div>
              <div v-if="transaction.hardware">
                <p
                  :class="fullscreen ? 'subtitle-1' : 'text-sm'"
                  class="text-truncate mb-0"
                >
                  {{ transaction.hardware.title_th }}
                  <span
                    :class="fullscreen ? 'subtitle-1' : 'text-sm'"
                    class="grey--text"
                  >
                    {{ transaction.hardware.hardware_code }}
                  </span>
                </p>
              </div>
              <div v-else>
                <p
                  :class="fullscreen ? 'subtitle-1' : 'text-sm'"
                  class="text-truncate mb-0"
                >
                  {{ transaction.transaction_source.title_short }}
                  <span
                    :class="fullscreen ? 'subtitle-1' : 'text-sm'"
                    class="grey--text"
                  >
                    {{ transaction.device_code_3rdparty }}
                  </span>
                </p>
              </div>
              <div>
                <div v-if="transaction.company_duty">
                  <p
                    :class="fullscreen ? 'subtitle-1' : 'text-sm'"
                    class="text-truncate mb-0"
                  >
                    สถานะ {{ transaction.company_duty.title_th }}
                  </p>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DeviceUseLeftView',
  props: {
    fullscreen: {
      type: Boolean,
      required: true
    },
    transactions: {
      type: Array,
      required: true
    }
  },
  filters: {
    datetimeFormat(transaction) {
      return moment
        .utc(transaction.transaction_time)
        .utcOffset(transaction.timezone)
        .format('DD/MM/YYYY HH:mm:ss')
    }
  },
  methods: {
    dateTimeFormat(value) {
      return `<span>${moment
        .utc(value.transaction_time)
        .utcOffset(value.timezone)
        .format('DD/MM/YYYY')}</span> <span class="primary--text">${moment
        .utc(value.transaction_time)
        .utcOffset(value.timezone)
        .format('HH:mm:ss')}</span>`
    },
    dateTimeFromNow(value) {
      return moment(value)
        .locale('th')
        .fromNow()
    }
  }
}
</script>

<style lang="scss" scoped>
.text-sm {
  font-size: 14px !important;
}
.text-md {
  font-size: 18px !important;
}
.text-lg {
  font-size: 24px !important;
}
.text-xl {
  font-size: 32px !important;
}
</style>
